// Expone la paleta de markers del tema activo como CSS custom properties
// con prefijo `--kln-marker-`. Permite que ENTITY_COLORS (map-constants.js)
// y cualquier componente que quiera pintar en el color del estado "normal"
// de un marker lea el hex correcto sin importar el archivo de paleta.
//
// Uso en main.js:
//   import { applyMarkerPalette } from '@/components/map-v2/theming/apply-markers'
//   applyMarkerPalette() // después de applyTheme()

import desaturado from './palettes/desaturado.js'
import vibrante from './palettes/vibrante.js'
import tactical from './palettes/tactical.js'
import neon from './palettes/neon.js'

const THEMES = { desaturado, vibrante, tactical, neon }
const STORAGE_KEY = 'kalan:theme'

// Temas CSS sin paleta de markers propia reusan la de otro tema. 'diurno'
// (tema claro) reusa la paleta de 'vibrante' hasta que se genere una paleta
// de markers clara dedicada. DEBE quedar sincronizado con el alias de
// icon-registry.js (ambos resuelven al mismo tema de markers, si no los
// SVGs del mapa y los `--kln-marker-*` quedarían de temas distintos).
const MARKER_ALIAS = { diurno: 'vibrante' }

function resolveMarkerThemeId(id) {
  const aliased = (id && MARKER_ALIAS[id]) || id
  return aliased && THEMES[aliased] ? aliased : 'desaturado'
}

function readActiveThemeId() {
  try {
    const persisted = localStorage.getItem(STORAGE_KEY)
    if (persisted) return resolveMarkerThemeId(persisted)
  } catch (_) { /* private mode */ }
  return 'desaturado'
}

export function applyMarkerPalette(themeId) {
  const id = themeId ? resolveMarkerThemeId(themeId) : readActiveThemeId()
  const theme = THEMES[id] || desaturado
  const root = document.documentElement
  Object.entries(theme.paleta).forEach(([nombre, hex]) => {
    root.style.setProperty('--kln-marker-' + nombre, hex)
  })
}

export function getActiveMarkerPalette() {
  const id = readActiveThemeId()
  return THEMES[id] || desaturado
}
